import { Boundaries } from "@planzone/core";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State } from "./types";

function handleFailure(
  state: State,
  { planzone }: Boundaries["retrieveZones"]["failure"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToFailure(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          planzone,
          zones: [],
          request: setRequestStateToFailure(),
        },
      ];
}

export { handleFailure };
